<template>
  <div>
    <b-collapse
      class="collapse-areas-wrapper"
      animation="slide"
      v-model="openDropdown"
      aria-id="filter-area"
    >
      <template #trigger="props">
        <div
          class="specific-search-wrapper"
          aria-controls="filter-area"
          :aria-expanded="props.open"
        >
          <div>
            <p class="averta-black label-15">Cari Lebih Spesifik</p>
            <p class="font-grey-tertiary">Masukan hanya kata kunci yang kamu ingin temukan</p>
          </div>
          <ButtonApp :isSecondary="true">
            <div class="is-flex is-align-items-center py-1 bg-white">
              <p class="averta-bold mr-2 is-hidden-mobile">
                {{ openDropdown ? 'Sembunyikan' : 'Lihat Filter' }}
              </p>
              <div class="chevron-search-specific" :class="{ open: !openDropdown }">
                <img :src="require('@/assets/icons/chevron-down-red.svg')" alt="" />
              </div>
            </div>
          </ButtonApp>
        </div>
      </template>
      <div class="mt-4 search-keyword-input">
        <p class="mb-1">Cari Berdasarkan</p>
        <b-input
          placeholder="ID/Nama PIC Proyek/No. Invoice"
          type="search"
          icon="magnify"
          icon-clickable
          v-model="keyword"
          @keyup.native.enter="handleSearch"
          class="averta-reguler label-14 input-none input-search-3"
        >
        </b-input>

        <div class="body-specific-search">
          <p class="mb-1">Pilih Client</p>
          <b-field class="input-none input-search-3 placeholder-specific-search">
            <b-autocomplete
              v-model="keywordVendor"
              placeholder="Pilih Client"
              :open-on-focus="true"
              :clearable="true"
              :data="filteredDataVendors"
              field="name"
              @select="(option) => handleSelectClient(option)"
            >
              <template slot-scope="props">
                <div class="item-client-wrapper">
                  <div class="logo-vendor-wrapper">
                    <img :src="props.option.logo" />
                  </div>
                  <p>{{ props.option.name }}</p>
                </div>
              </template>
            </b-autocomplete>
          </b-field>
          <div class="form-specific-search">
            <InputAutocompleteSpecificSearch
              v-if="isSMRC"
              title="Pilih Area"
              placeholder="Semua Area"
              :data="dataArea"
              @select="($event) => handleSelectItem({ data: $event, type: 'area' })"
            />
            <InputAutocompleteSpecificSearch
              :title="`Pilih ${isSMRC ? 'Unit' : 'Cabang'}`"
              :placeholder="`Semua ${isSMRC ? 'Unit' : 'Cabang'}`"
              :data="dataUnit"
              @select="($event) => handleSelectItem({ data: $event, type: 'unit' })"
            />
            <InputAutocompleteSpecificSearch
              :title="`Pilih ${isSMRC ? 'Building' : 'Outlet'}`"
              :placeholder="`Semua ${isSMRC ? 'Building' : 'Outlet'}`"
              :data="dataBuilding"
              @select="($event) => handleSelectItem({ data: $event, type: 'building' })"
            />

            <DropdownStatus
              widthFilter="145%"
              placeholder="Semua Status"
              :fromSpecificSearch="true"
              :selectedStatusProps="selectedStatus"
              @handleSelectItem="handleSelectItem"
            />

            <DropdownBasic
              v-if="isBorongan"
              title="Pilih Budget"
              placeholder="Pilih Budget"
              titleItemProps="title"
              :data="dataBudget"
              @select="($event) => handleSelectItem({ data: $event, type: 'budget' })"
            />

            <DropdownDateSpecificSearch
              title="Filter Tanggal Mulai Proyek"
              placeholder="Pilih Tanggal Mulai"
              @select="($event) => handleSelectItem({ data: $event, type: 'startDate' })"
            />
            <DropdownDateSpecificSearch
              title="Filter Tanggal Akhir Proyek"
              placeholder="Pilih Tanggal Akhir"
              @select="($event) => handleSelectItem({ data: $event, type: 'endDate' })"
            />
            <DropdownDateSpecificSearch
              title="Filter Tanggal Survey"
              placeholder="Pilih Tanggal Survey"
              @select="($event) => handleSelectItem({ data: $event, type: 'survey' })"
              :isRange="true"
            />
            <DropdownDateSpecificSearch
              title="Filter Tanggal Pembayaran"
              placeholder="Pilih Tanggal Pembayaran"
              @select="($event) => handleSelectItem({ data: $event, type: 'paid' })"
              :isRange="true"
            />
          </div>
        </div>
        <div class="is-flex is-justify-content-end mt-4">
          <button
            class="btn-reset-specific mr-3 c-w-sm-100"
            :class="{ disabled: disabled }"
            :disabled="disabled"
            @click="handleResetFilter"
          >
            <p class="averta-bold px-4 py-2">Reset Filter</p>
          </button>
          <ButtonApp :isDisabled="disabled" @click="handleSearch">
            <p class="averta-bold px-2 py-2">Tampilkan Hasil</p>
          </ButtonApp>
        </div>
      </div>
    </b-collapse>
  </div>
</template>

<script>
import moment from 'moment'
import { mapGetters } from 'vuex'
import { alertErrorMessage, isSMRC, userMenuPermissions } from '@/helpers'

export default {
  name: 'FormSpecificSearch',
  components: {
    ButtonApp: () => import('@/components/button/ButtonApp.vue'),
    DropdownStatus: () => import('@/components/dropdown/DropdownStatus.vue'),
    DropdownBasic: () => import('@/components/dropdown/DropdownBasic.vue'),
    DropdownDateSpecificSearch: () =>
      import('@/components/dropdown/DropdownDateSpecificSearch.vue'),
    InputAutocompleteSpecificSearch: () =>
      import('@/components/input/InputAutocompleteSpecificSearch.vue')
  },
  data () {
    return {
      isLoadingVendor: false,
      isLoadingArea: false,
      isLoadingUnit: false,
      isLoadingBuilding: false,
      isLoadingStatus: false,
      vendors: [],

      keywordVendor: '',
      keywordArea: '',
      keywordUnit: '',
      keywordBuilding: '',

      openDropdown: false,
      keyword: '',
      selectedClient: {
        name: null,
        code: null
      },
      selectedArea: {
        id: null,
        name: null
      },
      selectedUnit: {
        id: null,
        name: null
      },
      selectedBuilding: {
        id: null,
        name: null
      },
      selectedStartDate: null,
      selectedEndDate: null,
      selectedPaidDate: null,
      selectedSurveyDate: null,
      selectedStatus: null,
      selectedBudget: null,

      dataArea: [],
      dataUnit: [],
      dataBuilding: [],
      dataBudget: [
        {
          id: 1,
          title: 'Di bawah 10 juta',
          min: 0,
          max: 10000000
        },
        {
          id: 2,
          title: '10 juta s/d 30 juta',
          min: 10000000,
          max: 30000000
        },
        {
          id: 3,
          title: '30 juta s/d 100 juta',
          min: 30000000,
          max: 100000000
        },
        {
          id: 4,
          title: 'Di atas 100 juta',
          min: 100000000
        },
        {
          id: 0,
          title: 'Nominal Lainnya',
          inputNumber: true,
          value: null
        }
      ]
    }
  },
  computed: {
    ...mapGetters({
      url: 'setup/getUrl',
      statusSpecific: 'projectV2/getStatusSpecific',
      getSpecificSearch: 'projectV2/getSpecificSearch'
    }),
    disabled () {
      const isBudgetEmpty = this.selectedBudget && this.selectedBudget.inputNumber && !this.selectedBudget.value

      return (
        (!this.keyword || this.keyword.trim() === '') &&
        (!this.selectedClient || !this.selectedClient.name) &&
        (!this.selectedArea || !this.selectedArea.id) &&
        (!this.selectedUnit || !this.selectedUnit.id) &&
        (!this.selectedBuilding || !this.selectedBuilding.id) &&
        !this.selectedStartDate &&
        !this.selectedEndDate &&
        (!this.selectedStatus || !this.selectedStatus.type) &&
        !this.selectedPaidDate &&
        !this.selectedSurveyDate &&
        (!this.selectedBudget || isBudgetEmpty)
      )
    },
    filteredDataVendors () {
      return this.vendors.filter((option) => {
        return (
          option.name
            .toString()
            .toLowerCase()
            .indexOf(this.keywordVendor ? this.keywordVendor.toLowerCase() : '') >= 0
        )
      })
    },
    isSMRC () {
      return isSMRC(this.selectedClient && this.selectedClient.code ? this.selectedClient.code : '')
    },
    isBorongan () {
      const havePermission = userMenuPermissions('VIEW_BUDGET')
      return this.selectedClient && this.selectedClient.code === 'BORONGAN' && havePermission
    }
  },
  methods: {
    handleSelectClient (option) {
      this.selectedClient = option

      this.keywordArea = ''
      this.keywordUnit = ''
      this.keywordBuilding = ''

      this.dataArea = []
      this.dataUnit = []
      this.dataBuilding = []

      this.selectedArea = {
        id: null,
        name: null
      }
      this.selectedUnit = {
        id: null,
        name: null
      }
      this.selectedBuilding = {
        id: null,
        name: null
      }
      if (option && this.selectedClient && this.selectedClient.id) {
        if (this.isSMRC) {
          this.getListArea()
        } else {
          this.getListUnit()
        }
      }
    },
    handleSearch () {
      if (this.disabled) return
      const body = {
        keyword: this.keyword,
        client: this.selectedClient,
        area: this.selectedArea,
        unit: this.selectedUnit,
        building: this.selectedBuilding,
        start_date: this.selectedStartDate,
        end_date: this.selectedEndDate,
        type: this.selectedStatus ? this.selectedStatus.type : null,
        status: this.selectedStatus ? this.selectedStatus.status : null,
        paid_start_date: this.selectedPaidDate ? this.selectedPaidDate.start : null,
        paid_end_date: this.selectedPaidDate ? this.selectedPaidDate.end : null,
        start_survey_created_date: this.selectedSurveyDate ? this.selectedSurveyDate.start : null,
        end_survey_created_date: this.selectedSurveyDate ? this.selectedSurveyDate.end : null,
        budget: this.selectedBudget
      }
      this.$store.commit('projectV2/setSpecificSearch', body)
    },
    handleResetFilter () {
      this.keyword = ''
      this.keywordVendor = ''
      this.keywordArea = ''
      this.keywordUnit = ''
      this.keywordBuilding = ''

      this.selectedClient = {
        name: null,
        code: null
      }
      this.selectedArea = {
        id: null,
        name: null
      }
      this.selectedUnit = {
        id: null,
        name: null
      }
      this.selectedBuilding = {
        id: null,
        name: null
      }
      this.selectedStatus = null
      this.selectedStartDate = ''
      this.selectedEndDate = ''
    },
    handleSelectItem (props) {
      const { data, type } = props
      if (type === 'area') {
        this.selectedArea = data

        this.keywordUnit = ''
        this.keywordBuilding = ''
        this.dataUnit = []
        this.dataBuilding = []

        this.selectedUnit = {
          id: null,
          name: null
        }
        this.selectedBuilding = {
          id: null,
          name: null
        }
        this.selectedBudget = null
        if (this.isSMRC && data) {
          this.getListUnit()
        }
      }
      if (type === 'unit') {
        this.selectedUnit = data
        this.selectedBuilding = {
          id: null,
          name: null
        }
        if (data) {
          this.getListBuilding()
        }
      }
      if (type === 'building') {
        this.selectedBuilding = data
      }
      if (type === 'startDate') {
        this.selectedStartDate = data
      }
      if (type === 'endDate') {
        this.selectedEndDate = data
      }
      if (type === 'status') {
        this.selectedStatus = data
      }
      if (type === 'paid') {
        this.selectedPaidDate = data
      }
      if (type === 'survey') {
        this.selectedSurveyDate = data
      }
      if (type === 'budget') {
        if (data && data.inputNumber && !data.value) {
          this.selectedBudget = null
        } else {
          this.selectedBudget = data
        }
      }
    },
    formatDate (date, range) {
      const format = 'dddd, DD MMMM YYYY'
      if (!date) return '-'
      if (range) {
        const { start, end } = date
        if (start.toString() === end.toString()) {
          return moment(start).format(format)
        }
        return `${moment(start).format(format)} - ${moment(end).format(format)}`
      }
      return moment(date).format(format)
    },
    getListVendor () {
      this.isLoadingVendor = true
      this.$store
        .dispatch('client/getListVendor', { url: this.url })
        .then((response) => {
          const res = response.data.data.list
          this.vendors = res
          this.isLoadingVendor = false
        })
        .catch((error) => {
          this.isLoadingVendor = false
          alertErrorMessage(error)
        })
    },
    getListArea () {
      this.isLoadingArea = true
      const payload = {
        url: this.url,
        vendor_id: this.selectedClient.id
      }

      this.$store
        .dispatch('client/getAreasSMRC', payload)
        .then((response) => {
          const res = response.data.data
          this.dataArea = res.list
          this.isLoadingArea = false
        })
        .catch((error) => {
          alertErrorMessage(error)
          this.isLoadingArea = false
        })
    },
    getListUnit () {
      this.isLoadingUnit = false
      const payload = {
        url: this.url,
        vendor_id: this.selectedClient.id
      }

      if (this.isSMRC) {
        payload.area_id = this.selectedArea.id
      }

      this.$store
        .dispatch('client/getListBranch', payload)
        .then((response) => {
          const res = response.data.data
          this.dataUnit = res.list
          this.isLoadingUnit = false
        })
        .catch((error) => {
          this.isLoadingUnit = false
          alertErrorMessage(error)
        })
    },
    getListBuilding () {
      this.isLoadingBuilding = true

      const payload = {
        url: this.url,
        branch_id: this.selectedUnit ? this.selectedUnit.id : null,
        search: this.search
      }

      this.$store
        .dispatch('client/getListStore', payload)
        .then((response) => {
          const res = response.data.data
          this.dataBuilding = res.list
          this.isLoadingBuilding = false
        })
        .catch((error) => {
          this.isLoadingBuilding = false
          alertErrorMessage(error)
        })
    }
  },
  created () {
    this.getListVendor()
    setTimeout(() => {
      this.openDropdown = true
    }, 300)

    if (this.getSpecificSearch) {
      if (this.getSpecificSearch.keyword) {
        this.keyword = this.getSpecificSearch.keyword
      }
      if (this.getSpecificSearch.client && this.getSpecificSearch.client.name) {
        this.keywordVendor = this.getSpecificSearch.client.name
      }
    }
  },
  watch: {
    getSpecificSearch: {
      handler (val) {
        if (val.keyword) {
          this.keyword = val.keyword
        }
        if (val.client && val.client.name) {
          this.keywordVendor = val.client.name
        }
      },
      deep: true
    }
  }
}
</script>

<style scoped>
.collapse-areas-wrapper {
  border: 1px solid #e1e1e1;
  padding: 18px;
  border-radius: 10px;
  background: #fafafa;
}

.specific-search-wrapper {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: auto;
}

.body-specific-search {
  border-top: 1px dashed #c1c7d3;
  border-bottom: 1px dashed #c1c7d3;
  margin-top: 20px;
  padding-top: 15px;
  padding-bottom: 20px;
}

.form-specific-search {
  display: grid;
  /* grid-template-columns: repeat(3, 1fr); */
  grid-template-columns: repeat(auto-fit, minmax(310px, 1fr));
  gap: 15px;
}

.dropdown-specific-wrapper {
  box-shadow: 6px 7px 50px 0px #00000014;
  position: absolute;
  top: 80px;
  right: 0px;
  width: 100%;
  background: white;
  z-index: 5;
  overflow: hidden;
}

.dropdown-specific-wrapper.status {
  width: 145%;
  border-radius: 10px;
}

.content-dropdown-wrapper {
  max-height: 160px;
  width: 100%;
  overflow: auto;
}

.content-dropdown-wrapper.status {
  max-height: 200px;
}

.item-content-dropdown {
  padding: 15px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
}

.item-content-dropdown:hover,
.item-content-dropdown.active {
  background: #e100091a;
}

.item-content-dropdown:not(:last-child) {
  border-bottom: 1px solid #e1e1e1;
}

.custom-radio-button {
  width: 20px;
  height: 20px;
  border-radius: 10px;
  border: 1px solid #868686;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 5px;
  flex-shrink: 0;
}

.custom-radio-button.active::before {
  content: '';
  display: inline-block;
  width: 14px;
  height: 14px;
  border-radius: 10px;
  background: #e10009;
}

.chevron-search-specific {
  position: relative;
  transition: all 0.2s ease-in-out;
}

.chevron-search-specific.open {
  transform: rotate(180deg);
  transform-origin: center;
}

.btn-reset-specific {
  border-radius: 100px;
  border: 1px solid #e10009;
  color: #e10009;
  background: white;
  cursor: pointer;
}

.btn-reset-specific.disabled {
  pointer-events: none;
  border: 1px solid #c1c7d3;
  color: #9a9a9a;
}

.item-client-wrapper {
  display: flex;
  align-items: center;
  border-bottom: 1px solid #e1e1e1;
  padding: 5px 0;
}

.logo-vendor-wrapper {
  width: 80px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 10px;
}

.logo-vendor-wrapper img {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
}
</style>

<style>
.placeholder-specific-search input,
.placeholder-specific-search input::placeholder,
.placeholder-specific-search input::-webkit-input-placeholder {
  color: #474747;
}

.search-keyword-input input {
  /* border: 1px solid #e1e1e1; */
  border-radius: 10px;
  font-size: 14px;
  padding: 20.5px 10px;
}

.search-keyword-input span.icon {
  top: 6px !important;
}

.dropdown-filter-pembayaran .dropdown-content {
  padding-bottom: 0 !important;
  padding-top: 0 !important;
}
</style>
